import { OMNICHANNEL_REQUEST_SERVICE_APPLET_ID } from '../../../constants/omnichannelModals';
import { ServiceOrderDetails } from '../../../types/service-order';
import { useEffect, useRef } from 'react';

export interface EditPurchaseOrderInfoModalProps {
  serviceOrderDetails: ServiceOrderDetails;
}

export default function ServiceRequestModal({
  serviceOrderDetails,
}: EditPurchaseOrderInfoModalProps) {
  const requestServiceOmnichannelModalId = `${OMNICHANNEL_REQUEST_SERVICE_APPLET_ID}-modal`;
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    try {
      // Check if there's already an existing element with this ID
      const existingEl = document.getElementById(requestServiceOmnichannelModalId);

      // If element exists and is different from our ref, remove it
      if (existingEl && existingEl !== elementRef.current) {
        existingEl.remove();
      }

      // Create a new element only if we don't have one already
      if (!elementRef.current) {
        const el = document.createElement('div');
        el.setAttribute('id', requestServiceOmnichannelModalId);
        elementRef.current = el;
        document.body.appendChild(el);
      }

      // Always update the attributes with the latest data
      if (elementRef.current) {
        elementRef.current.setAttribute('rendersignin', 'false');
        elementRef.current.setAttribute('location-id', serviceOrderDetails.locationId);
        elementRef.current.setAttribute('asset-id', serviceOrderDetails.assetId);
        elementRef.current.setAttribute('assettype', serviceOrderDetails.assetType);
        elementRef.current.setAttribute('assetlocation', serviceOrderDetails.assetAddress);
        elementRef.current.setAttribute('fullname', serviceOrderDetails.fullName);
        elementRef.current.setAttribute('servicelocation', serviceOrderDetails.serviceLocation);
        elementRef.current.setAttribute('serviceissue', serviceOrderDetails.serviceDescription);
        elementRef.current.setAttribute('companyname', serviceOrderDetails.companyName);
        elementRef.current.setAttribute('phonenumber', String(serviceOrderDetails.phone));
        elementRef.current.setAttribute('emailaddress', serviceOrderDetails.email);
      }
    } catch (error) {
      console.error('Error in ServiceRequestModal:', error);
    }

    // Cleanup function when component unmounts
    return () => {
      // We intentionally don't remove the element on unmount
      // to prevent React root re-creation issues
      // The element will be reused or cleaned up when the app navigates
    };
  }, [
    requestServiceOmnichannelModalId,
    serviceOrderDetails.locationId,
    serviceOrderDetails.assetId,
    serviceOrderDetails.assetType,
    serviceOrderDetails.assetAddress,
    serviceOrderDetails.fullName,
    serviceOrderDetails.serviceLocation,
    serviceOrderDetails.serviceDescription,
    serviceOrderDetails.companyName,
    serviceOrderDetails.phone,
    serviceOrderDetails.email,
  ]);

  return <></>;
}
